import { Component, Input, OnInit } from '@angular/core';
import { SLEntity } from '../entity';
import { SLMovementAttachment } from '../movement';

interface MovementItem {
  id: string
  no: number
  attachments: SLMovementAttachment[]
}

@Component({
  selector: 'sl-entity-attachments',
  templateUrl: './entity-attachments.component.html',
})
export class SLEntityAttachmentsComponent implements OnInit {

  @Input()
  entity: SLEntity

  movements: MovementItem[]
  attachmentsCount = 0

  ngOnInit() {
    this.movements = [];
    let no = 1;

    for (let {id, attachments} of this.entity.movements) {
      if (attachments.length > 0) {
        this.movements.push({
          id,
          no,
          attachments,
        });

        this.attachmentsCount += attachments.length;
      }

      no++;
    }
  }
}
